var site = site || {};
site.additions = site.additions || {};
site.additions.initDone = false;
/*
 Additions
 */
site.additions.upload =  {
	init: function(urls, lang) {
		if(site.additions.initDone === false) {
			site.additions.initDone = true;
			$('ul#images').sortable({
				'opacity': 0.8,
				'update': function (e, ui) {
					var $el = $(this);
					$el.sortable('disable').addClass('disabled');
					$.post(urls.sort, $(this).sortable('serialize'), function (d) {
						if (d.success !== true) {
							moya.message.add(lang.galleryErrorOnSave);
							$el.sortable('cancel');
						}
						$el.removeClass('disabled');
						$el.sortable('enable');
					});
				}
			});
			$('#ffile').uploadify({
				'uploader': '/_moya/js/jquery/uploadify/uploadify.swf',
				'script': urls.script,
				'cancelImg': '/_moya/js/jquery/uploadify/cancel.png',
				'auto': true,
				'multi': true,
				'folder': '/tmp',
				'fileDesc': lang.galleryImageUploadFileDescription,
				'fileExt': '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG',
				'buttonText': lang.galleryImageAdd,
				'queueID': 'ffileQueue',
				'onError': function () {
					$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
				},
				'onComplete': function (e, q, f, r) {
					var n = $('#notice');
					switch (r) {
						case 'noAlbum':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
							break;
						case 'noSave':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
							break;
					}
				},
				'onAllComplete': function () {
					window.location.reload();
				}
			});
		}
	}
};

site.additions = $.extend(site.additions, {
	itemForm: function() {
		$('select#urlSitemap').bind('change click keyup', function() {
			$('input#url').val($(this).val());
		});
	}
});

site.additions = $.extend(site.additions, {
	addFilter: function() {
		$('#additions .hasFilter').mixItUp({
			animation: {
				effects: 'fade'
			}
			/*
			load: {
				filter: 'none'
			},
			controls: {
				toggleFilterButtons: true
			}*/
		});
	}
});

site.additions = $.extend(site.additions, {
	weekCarousel: function() {
		var d = new Date();
		var start = d.getDay();

		var $owl = $('#weekView .items');
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3

			$owl.owlCarousel({
				smartSpeed: 400,
				dots:false,
				nav:true,
				rewind:false,
				navText:['<i class="fa fa-angle-left" />','<i class="fa fa-angle-right" />'],
				items : 3,
				responsive: {
					0: {
						items:1
					},
					768: {
						items:2
					},
					979: {
						items:3
					},
					1199: {
						items:3
					}
				}
			});
			$owl.trigger('to.owl.carousel',[start,0,true]);
		}
	}
});
